<template>
  <v-container class="booking-preview p-0" v-if="subscription && facilityType" fluid>
    <vue-headful :title="$t('header.facility') + $t('title')"></vue-headful>
    <HkiaraceBannerFrame :src="'api/static/'+facilityType.banner"
                         :label="facilityType.name.toUpperCase()"
                         :is-snap-content="true">
      <v-row class="booking-preview-content">
        <v-col class="booking-preview-content-wrapper p-0">
          <v-row class="booking-preview-content-row mb-3 py-3">
            <v-col>
              <v-form v-model="isFormValid" class="booking-preview-form text-left">
                <v-container>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-row class="booking-preview-form-title">
                        <v-col>{{ $t('gym_subscription.purchase_preview') }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field readonly
                                        hide-details
                                        :label="$t('booking.reserved_at')"
                                        :value="reservedAtLabel"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field readonly
                                        hide-details
                                        :label="$t('booking.facility')"
                                        :value="facilityItemLabel"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-select :label="$t('booking.coupons')"
                                    hide-details
                                    :items="couponOptions"
                                    v-model="selectedCoupon"></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field v-if="!discountCodeRecord"
                                        outlined
                                        hide-details="auto"
                                        :label="$t('booking.discount_code')"
                                        v-model="discountCode"
                                        :error-count="!!discountCodeErrorMessage ? 1 : 0"
                                        :error-messages="discountCodeErrorMessage"
                                        append-icon="mdi-check"
                                        @click:append="applyDiscountCode"
                                        @keydown.enter="applyDiscountCode"></v-text-field>
                          <v-text-field v-if="discountCodeRecord"
                                        readonly
                                        hide-details="auto"
                                        :label="$t('booking.discount_code')"
                                        :value="discountCode"
                                        :error-count="!!discountCodeErrorMessage ? 2 : 0"
                                        :error-messages="discountCodeErrorMessage ? [discountCodeDescriptions, discountCodeErrorMessage] : []"
                                        append-outer-icon="mdi-close"
                                        @click:append-outer="clearDiscountCode"
                                        :hint="discountCodeDescriptions"
                                        persistent-hint>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field readonly
                                        hide-details
                                        :label="$t('booking.fee')"
                                        :value="priceLabel"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-checkbox light
                                      v-model="acceptedConsent"
                                      @click.stop="showConsent"
                                      validate-on-blur>
                            <template v-slot:label>
                              <div @click.stop="showConsent">{{ $t('gym_subscription.consent') }}</div>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-checkbox light
                                      v-model="accepted"
                                      @click.stop="showTnc"
                                      validate-on-blur>
                            <template v-slot:label>
                              <div @click.stop="showTnc">{{ $t('booking_preview.accept_tnc1') }} {{ $t('booking_preview.accept_tnc2') }}</div>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-row class="booking-preview-form-title">
                        <b-col>{{ $t('booking_preview.time_left') }} {{ timeLeft }}</b-col>
                      </v-row>
                      <v-row class="preview-warning-label">
                        <v-col>{{ $t('booking_preview.preview_warning') }}</v-col>
                      </v-row>
                      <v-row class="booking-preview-form-title">
                        <v-col class="pb-0">{{ $t('booking.payment_method') }}</v-col>
                      </v-row>
                      <v-row v-if="price <= 0">
                        <v-col cols="12"
                               :class="['pa-8', 'text-center', 'booking-preview-payment-method', 'enabled', 'active']">
                          {{ $t('booking.no_need_to_pay') }}
                        </v-col>
                      </v-row>
                      <v-row v-if="price > 0">
                        <v-col class="pt-0">
                          <v-item-group>
                            <v-container>
                              <v-row>
                                <v-col cols="12"
                                       :class="['booking-preview-payment-method', {'active': paymentMethod === 'cyber_source'}]"
                                       @click="paymentMethod = 'cyber_source'">
                                  <v-img :src="require('../../../assets/logo-credit-cards.png')"></v-img>
                                </v-col>
                                <!--                                <v-col cols="1"></v-col>-->
                                <!--                                <v-col cols="4"-->
                                <!--                                       :class="['booking-preview-payment-method', {'active': paymentMethod === 'union_pay'}]"-->
                                <!--                                       @click="paymentMethod = 'union_pay'">-->
                                <!--                                  <v-img :src="require('../../../assets/logo-union-pay.png')"></v-img>-->
                                <!--                                </v-col>-->
                              </v-row>
                              <v-row v-if="paymentMethod === 'cyber_source'">
                                <v-col>
                                  <v-radio-group v-model="selectedPaymentToken">
                                    <v-radio v-for="paymentToken in paymentTokens"
                                             :key="paymentToken.id"
                                             :value="paymentToken.id">
                                      <template #label>
                                        <v-img :src="cardTypeLogo[paymentToken.card_type]"
                                               :max-width="40"
                                               :max-height="30"
                                               class="mr-4"></v-img>
                                        {{ `${paymentToken.card_number} (${paymentToken.card_expiry_date})` }}
                                      </template>
                                    </v-radio>
                                    <v-radio :value="false">
                                      <template #label>
                                        <v-icon class="mr-4">fas fa-plus-square</v-icon>
                                        {{ $t('booking_preview.add_payment_token') }}
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-item-group>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-col>
          </v-row>

          <v-row class="booking-preview-steps  py-2 px-2 py-md-6 px-md-6">
            <v-col cols="12" v-if="$vuetify.breakpoint.width > 600">
              <v-avatar color="primary" size="36">
                <span class="text-white">1</span>
              </v-avatar>
              <span>{{ $t('booking.step_1') }}</span>
              <v-icon>mdi-arrow-right</v-icon>
              <v-avatar color="primary" size="36">
                <span class="text-white">2</span>
              </v-avatar>
              <span>{{ $t('booking.step_2') }}</span>
              <v-icon>mdi-arrow-right</v-icon>
              <v-avatar color="grey" size="36">
                <span class="text-white">3</span>
              </v-avatar>
              <span class="text-muted">{{ $t('booking.step_3') }}</span>
              <!--                    <v-btn color="primary" rounded large-->
              <!--                           :disabled="!selectedTimeSlots.length"-->
              <!--                           @click="reserveTimeSlots"-->
              <!--                           class="ml-9">-->
              <!--                        <v-icon>mdi-arrow-right-circle-outline</v-icon>-->
              <!--                        {{$t('booking.next_step')}}-->
              <!--                    </v-btn>-->
            </v-col>
            <v-col cols="6" v-if="$vuetify.breakpoint.width <= 600" class="text-left font-size-25">
              <v-row>
                <v-col>
                  <v-avatar color="primary" size="36">
                    <span class="text-white">1</span>
                  </v-avatar>
                  <span>{{ $t('booking.step_1') }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-avatar color="primary" size="36">
                    <span class="text-white">2</span>
                  </v-avatar>
                  <span>{{ $t('booking.step_2') }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-avatar color="grey" size="36">
                    <span class="text-white">3</span>
                  </v-avatar>
                  <span class="text-muted">{{ $t('booking.step_3') }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col :class="$vuetify.breakpoint.width <= 600?'text-center':'text-right'" :cols="$vuetify.breakpoint.width <= 600?6:12">
              <v-btn color="primary" rounded :large="$vuetify.breakpoint.width>600"
                     class="ml-2 my-2"
                     :disabled="!isFormValid || !accepted || (!paymentMethod && price > 0) || !acceptedConsent"
                     @click="next">
                <v-icon>mdi-arrow-right-circle-outline</v-icon>
                <span class="font-size-35">{{ $t('booking.next_step') }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </HkiaraceBannerFrame>
    <!--        <v-row class="booking-preview-banner">-->
    <!--            <v-col class="p-0">-->
    <!--                <v-carousel hide-delimiters-->
    <!--                            :show-arrows="false">-->
    <!--                    <v-carousel-item :src="'api/static/'+facilityType.banner">-->
    <!--                        <div class="booking-preview-banner-label">-->
    <!--                            {{facilityType.name.toUpperCase()}}-->
    <!--                        </div>-->
    <!--                    </v-carousel-item>-->
    <!--                </v-carousel>-->
    <!--            </v-col>-->
    <!--        </v-row>-->
    <v-dialog v-model="tncDialogShown" scrollable>
      <v-card light v-if="tnc">
        <v-card-title class="tnc-title title-font">{{ tnc.title }}</v-card-title>

        <v-card-text @click="onScroll" @scroll="onScroll" v-html="tnc.content" class="text-left" ref="tncContent"></v-card-text>

        <v-card-actions class="tnc-actions">
          <v-spacer></v-spacer>
          <span v-if="!tncScrolledToBottom">{{ $t('booking.tnc_scroll_to_bottom') }}</span>
          <v-spacer></v-spacer>

          <v-btn text
                 :disabled="!tncScrolledToBottom"
                 class="tnc-action title-font"
                 @click="setAcceptTnc(true)">
            {{ $t('register.agree') }}
          </v-btn>

          <v-btn text
                 :disabled="!tncScrolledToBottom"
                 class="tnc-action title-font"
                 color="rgb(142, 118, 91)"
                 @click="setAcceptTnc(false)">
            {{ $t('register.disagree') }}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="gymDialogShown" persistent scrollable content-class="consent-dialog">
      <v-card light>
        <v-card-title class="tnc-title title-font">{{ $t('gym_subscription.name') }}</v-card-title>

        <v-card-text class="text-left">
          <!--          <GymVideoPlayer v-if="gymDialogShown" ref="gymVideoPlayer" class="gymVideoPlayer"/>-->
          <!--<youtube video-id="3irVy7zN47w" :player-vars="{ autoplay: 1 }"></youtube>-->
          <ol v-if="$i18n.locale === 'en'">
            <li>Persons having consumed alcohol, suffering from high blood pressure, heart disease or other physical conditions are advised not to use the Gymnasium.</li>
            <li>Users are advised to check their own physical conditions and familiarise themselves with the mechanism of the equipment before using it in the Gymnasium.</li>
            <li>Not all of the equipment and/facilities and/activities are suitable for everyone and if in doubt, users shall seek their own advice. By using the equipment and/or facilities and/or participating the activities/programmes, users are deemed to have taken steps to ensure that they are physically fit to use such equipment/facilities or participate in activities/programmes.</li>
            <li>Users should be responsible for their own personal safety. The Clubhouse management will not be responsible for death or injury to any person arising out of or in connection with the use of any of the equipment in the Gymnasium.</li>
            <li>Users must use the equipment and perform respective activities in the designated area.</li>
          </ol>
          <ol v-if="$i18n.locale === 'zh'">
            <li>建議使用者凡飲酒後或本身患有高血壓、心臟病或身體出現其他狀況，應暫停使用健身室內設施。</li>
            <li>使用健身器械前，請先自行檢查身體狀況及了解器械的使用方法。</li>
            <li>健身室內所有設備 / 設施 / 活動並非完全適合所有人使用或參與，如有任何疑問，使用者應自行向醫生查詢。凡使用設備 / 設施或參與活動，即表示使用者已確保其身體狀況適合使用該設備 / 設施或參與該活動。</li>
            <li>使用者必須自行負責個人安全。所有因使用健身室設施而引致或與之相關的任何傷亡，會所管理公司概不負責。</li>
            <li>使用者必須在指定區域內使用設備並進行相關活動。</li>
          </ol>
        </v-card-text>

        <v-card-actions class="tnc-actions">
          <v-spacer></v-spacer>
          <span>{{ $t('gym_subscription.question_consent') }}</span>
          <v-btn text
                 class="tnc-action title-font"
                 @click="setAcceptConsent(true)">
            {{ $t('yes') }}
          </v-btn>

          <v-btn text
                 class="tnc-action title-font"
                 color="rgb(142, 118, 91)"
                 @click="setAcceptConsent(false)">
            {{ $t('no') }}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faExclamationCircle} from '@fortawesome/free-solid-svg-icons'
import {DateTime} from 'luxon'
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
import {computed, onBeforeUnmount, onMounted, ref, watch} from '@vue/composition-api';
import GymVideoPlayer from "../../../components/acc_booking/GymVideoPlayer";
import _ from "lodash";

library.add(faExclamationCircle);

export default {
  name: 'GymPassPreview',
  components: {GymVideoPlayer, HkiaraceBannerFrame},
  setup(props, {root}) {
    const facilityType = ref(null);
    const getFacilityType = function () {
      root.$callAPI('aafb/gym_subscription/get_facility_type/', {}, function (response) {
        facilityType.value = response.body.facility_type;
      });
    };

    const subscription = ref(null);


    const isFormValid = ref(false);

    const reservedAtLabel = computed(() => {
      return subscription.value ? DateTime.fromISO(subscription.value.create_at).toFormat('yyyy-MM-dd | HH:mm') : '';
    });
    const facilityItemLabel = computed(() => {
      return (subscription.value && facilityType.value) ? facilityType.value.name + ' ' + subscription.value.type.name : '';
    });
    const priceLabel = computed(() => {
      if (subscription.value) {
        const price = subscription.value.price - (selectedCoupon.value ? selectedCoupon.value.amount : 0) - discountCodeDiscount.value;
        return 'HKD ' + price;
      }
    });

    // Coupon
    const selectedCoupon = ref(null);
    const coupons = ref([]);
    const couponOptions = computed(() => [
      {value: null, text: root.$t('booking.no_coupon')},
      ...coupons.value.map((c) => {
        return {
          value: c,
          text: `HKD ${c.amount} - ${c.gym_pass_type.name} - ${c.id.substr(0, 6)}`,
        }
      }),
    ]);
    const getCoupons = function () {
      root.$callAPI('aafb/coupon/', {gym_pass_type_id: subscription.value.type.id, show_only_valid: true}, function (response) {
        coupons.value = response.body.coupons;
      })
    }

    const discountCode = ref(null);
    const discountCodeError = ref(null);
    const discountCodeRecord = ref(null);
    const discountCodeErrorMessage = computed(() => {
      if (discountCodeError.value) return discountCodeError.value;

      if (discountCodeRecord.value && subscription.value) {
        const discountCode = discountCodeRecord.value.discount_code;
        // Discount Code Type
        if (discountCode.type !== 'GYM_PASS') return root.$t('error_messages.discount_code_not_applicable');

        // Item Type
        if (discountCode.gym_pass_type) {
          if (discountCode.gym_pass_type.id !== subscription.value.type.id) {
            return root.$t('error_messages.discount_code_not_applicable');
          }
        } else {
          return root.$t('error_messages.discount_code_not_applicable');
        }
      }

      return null;
    })
    const discountCodeDescriptions = computed(() => {
      if (discountCodeRecord.value) {
        return root.$getDiscountCodeDescription(discountCodeRecord.value.discount_code);
      }
    })
    const discountCodeDiscount = computed(() => {
      if (discountCodeRecord.value && !discountCodeErrorMessage.value) {
        const discountCode = discountCodeRecord.value.discount_code;

        if (discountCode.discount_value > 0) return discountCode.discount_value;

        return Math.floor((subscription.value.price - (selectedCoupon.value ? selectedCoupon.value.amount : 0)) * discountCode.discount_percentage / 100);
      }

      return 0;
    })
    const getAppliedDiscountCode = function () {
      root.$callAPI('aafb/applied_discount_code/', {
        gym_subscription_id: subscription.value.id,
      }, (response) => {
        if (response.body.record) {
          discountCodeRecord.value = response.body.record;
          discountCode.value = response.body.record.discount_code.code;
        } else {
          discountCodeRecord.value = null;
          discountCode.value = null;
        }
      })
    }
    const applyDiscountCode = function () {
      if (discountCode.value) {
        discountCodeError.value = null;
        root.$callAPI('aafb/gym_subscription/apply_code/', {
          subscription_id: subscription.value.id,
          'code': discountCode.value,
        }, (response) => {
          if (response.body.record) {
            discountCodeRecord.value = response.body.record;
            discountCode.value = response.body.record.discount_code.code;
          } else {
            discountCodeRecord.value = null;
            discountCode.value = null;
          }
        }, (response) => {
          discountCodeError.value = root.$t(`error_messages.${response.body.msg || 'invalid_discount_code'}`);
          console.log(response);
        })
      }
    }
    const clearDiscountCode = function () {
      if (discountCodeRecord.value && confirm(root.$t('booking.clear_discount_code'))) {
        discountCodeError.value = null;
        root.$callAPI('aafb/gym_subscription/clear_code/', {
          subscription_id: subscription.value.id,
        }, () => {
          getAppliedDiscountCode()
        }, (response) => {
          console.log(response);
        })
      }
    }
    const price = computed(() => {
      if (selectedCoupon.value) {
        return subscription.value.price - selectedCoupon.value.amount;
      } else {
        return subscription.value.price;
      }
    })

    const tnc = ref(null);
    const getTNC = function () {
      root.$callAPI('hkiarace/tnc/', {}, function (response) {
        tnc.value = response.body;
      });
    };
    const accepted = ref(false);
    const tncDialogShown = ref(false);
    const tncScrolledToBottom = ref(false);

    const showTnc = function (e) {
      e.preventDefault();

      if (!accepted.value) {
        // this.$bvModal.show('tncModal');
        tncDialogShown.value = true;

        setTimeout(() => {
          onScroll({target: tncContent.value});
        }, 500)
      } else {
        accepted.value = false;
      }
    };
    const setAcceptTnc = function (accept) {
      tncDialogShown.value = false;
      accepted.value = accept;
    };

    const tncContent = ref();
    const onScroll = function ({target: {scrollTop, clientHeight, scrollHeight}}) {
      if (scrollTop + clientHeight >= (scrollHeight - 10)) {
        tncScrolledToBottom.value = true
      }
    };

    const acceptedConsent = ref(false);
    const gymDialogShown = ref(false);
    const showConsent = function (e) {
      e.preventDefault();

      if (!acceptedConsent.value) {
        // this.$bvModal.show('tncModal');
        gymDialogShown.value = true;
      } else {
        acceptedConsent.value = false;
      }
    };
    const setAcceptConsent = function (accept) {
      gymDialogShown.value = false;
      acceptedConsent.value = accept;

      // this.$refs.gymVideoPlayer.destroyWidget()
    };

    const timeLeft = ref('10:00');
    const countDownInterval = ref(null);
    const calculateTimeLeft = function () {
      let valid_until = DateTime.fromISO(subscription.value.create_at).plus({minutes: 10});

      // if (DateTime.local() > valid_until || subscription.value.status !== 0) {
      //   if (confirm(root.$t('booking_preview.order_expired_msg')) || true) {
      //     root.$router.replace({name: 'booking-list'})
      //   }
      // }

      if (DateTime.local() > valid_until || subscription.value.status !== 0) {
        clearInterval(countDownInterval.value)
        root.$showAlertMessage(
          root.$t('booking_preview.order_expired_msg'),
          () => {
            root.$router.replace({name: 'booking-list'})
          }
        )
      }

      let diff = valid_until.diff(DateTime.local(), ['minutes', 'seconds']);

      timeLeft.value = Math.floor(diff.minutes).toString().padStart(2, '0') + ":" + Math.floor(diff.seconds).toString().padStart(2, '0');
    };
    const paymentMethod = ref(null);

    // Payment Token
    const selectedPaymentToken = ref(false);
    const paymentTokens = ref([]);
    const cardTypeLogo = ref({
      '001': require('@/assets/visa.jpg'),
      '002': require('@/assets/mastercard.png'),
      '007': require('@/assets/jcb.gif'),
    });
    const getPaymentTokens = function () {
      root.$callAPI('payment/cyber_source/payment_tokens/', {}, (response) => {
        paymentTokens.value = response.body.payment_tokens;

        if (paymentTokens.value.length > 0) {
          selectedPaymentToken.value = paymentTokens.value[0].id;
        }
      })
    }
    watch(() => paymentMethod.value, (newValue) => {
      if (newValue === 'cyber_source') {
        getPaymentTokens();
      }
    })

    const getSubscription = function () {
      root.$callAPI('aafb/gym_subscription/', {subscription_id: root.$route.params.subscriptionId}, function (response) {
        subscription.value = response.body.subscription;

        countDownInterval.value = setInterval(calculateTimeLeft, 1000);

        getCoupons();
        getAppliedDiscountCode();
      })
    };

    const postForm = function (path, params, method = 'post') {
      const form = document.createElement('form');
      form.method = method;
      form.action = path;

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = params[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
      root.$startLoading();
    }
    const next = function () {
      if (confirm(root.$t('booking_preview.redirect_warning'))) {
        this.$callAPI('aafb/gym_subscription/init_payment/', {
          coupon_id: selectedCoupon.value ? selectedCoupon.value.id : null,
          payment_method: price.value > 0 ? paymentMethod.value : 'NO_NEED_TO_PAY',
          subscription_id: subscription.value.id,
          payment_token_id: selectedPaymentToken.value,
        }, function (response) {
          if (response.body.no_need_to_pay) {
            root.$router.replace({name: 'gym-pass-confirm', params: {subscriptionId: subscription.value.id}});
          } else {
            postForm(response.body.url, response.body.params)
          }
        });
      }
    };

    onMounted(() => {
      getFacilityType();
      getSubscription();
      getTNC();
    });

    onBeforeUnmount(() => {
      clearInterval(countDownInterval.value);
    })

    return {
      facilityType,
      subscription,

      isFormValid,

      reservedAtLabel,
      facilityItemLabel,
      priceLabel,

      selectedCoupon,
      couponOptions,

      discountCode,
      discountCodeRecord,
      discountCodeErrorMessage,
      discountCodeDescriptions,
      discountCodeDiscount,
      applyDiscountCode,
      clearDiscountCode,

      price,

      tnc,
      accepted,
      tncDialogShown,
      tncScrolledToBottom,
      tncContent,
      onScroll,
      showTnc,
      setAcceptTnc,

      acceptedConsent,
      gymDialogShown,
      showConsent,
      setAcceptConsent,

      timeLeft,
      paymentMethod,

      selectedPaymentToken,
      paymentTokens,
      cardTypeLogo,

      next,
    }
  },
}
</script>

<style lang="less">
.booking-preview {
  .booking-preview-banner {
    .booking-preview-banner-label {
      position: absolute;
      left: 50%;
      top: 50%;
      color: white;
      font-size: 3rem;
      text-shadow: 2px 2px rgba(0, 0, 0, 0.25);
      transform: translate(-50%, -50%);
    }
  }

  .booking-preview-content {
    background-color: #efefef;

    .booking-preview-content-wrapper {
      /*transform: translateY(-120px);*/

      .datepicker-calendar {
        width: 100%;
        border: none;
        margin: auto;
      }

      .booking-preview-content-row {
        background-color: white;

        .booking-preview-form {
          max-width: 1024px;
          margin: auto;

          .v-label {
            color: #8E765B;
          }

          .v-input--is-readonly > .v-input__control > .v-input__slot:before {
            display: none;
          }

          .v-input--is-readonly > .v-input__control > .v-input__slot:after {
            display: none;
          }

          .booking-preview-form-title {
            font-size: 1.5rem;
          }

          .preview-warning-label {
            font-size: .8rem;
          }

          .booking-preview-payment-method {
            border: 2px solid rgba(0, 0, 0, 0.2);
            cursor: pointer;


            &:hover, &.active {
              border-color: #8E765B;
            }
          }
        }
      }

      .booking-preview-steps {
        .v-avatar {
          margin-right: 12px;
        }

        .mdi-arrow-right {
          margin-left: 24px;
          margin-right: 12px;
        }
      }
    }
  }
}


.consent-dialog {
  min-width: 400px;
  max-width: 800px;
  width: 800px;
}


.gymVideoPlayer {
  width: 100%;
  height: 640px;
  max-height: 60vh;
  max-width: 80vw;
}

</style>
